export const convertTrackingEntryURL = (
  pageTitle: string,
  companyID: number,
  device: string,
  pageID?: number,
  entryURL?: string,
  sourceURL?: string,
) => {
  if (!entryURL) {
    return undefined;
  }

  const baseUrl = `/tracking/company/${pageID}?entry_type=entry&page_title=${pageTitle}&company_id=${companyID}&device=${device}&entry_url=${encodeURIComponent(entryURL)}`;

  if (sourceURL) {
    return `${baseUrl}&source_url=${encodeURIComponent(sourceURL)}`;
  }

  return baseUrl;
};
